import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withTranslation } from 'react-i18next';
import logo from './zabka-logo.png'

const styles = {
  content: {
    backgroundColor: '#006420',
    color: '#fff',
    textAlign: 'center',
    '& a': {
      color: '#fff',
    },
  },
  actions: {
    backgroundColor: '#006420',
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 24,
  },
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: '#fff',
  },
  logo: {
    width: 100,
    height: 100,
    filter: 'brightness(0) invert(1)',
    marginTop: -12,
    marginBottom: -24,
  },
  title: {
    marginBottom: 8,
    fontWeight: 'bold',
    fontSize: '2.8rem',
  },
};

function FullpageCampaignConsentDialog(props) {
  const { classes, onCtaClick, t, value } = props;
  const [open, setOpen] = useState(value === false);

  return <Dialog open={open}>
    <DialogContent className={classes.content}>
      <img src={logo} alt="logo" className={classes.logo} />
      <IconButton aria-label="close" className={classes.closeButton} onClick={() => setOpen(false)}>
        <CloseIcon />
      </IconButton>
      <Typography variant="h3" className={classes.title}>{t('fullpageCampaignConsentDialog.title')}</Typography>
      <Typography variant="body2">
        {t('fullpageCampaignConsentDialog.consentText')}
      </Typography>
      <Typography variant="body2">
        {t('fullpageCampaignConsentDialog.termsInfo')} <a href="https://zeccer.pl/bonzabka" target="_blank" rel="noreferrer">zeccer.pl/bonzabka</a>.
      </Typography>
    </DialogContent>
    <DialogActions className={classes.actions}>
      <Button variant="contained" color="primary" size="large" onClick={() => {
        setOpen(false);
        onCtaClick();
      }}>
        {t('fullpageCampaignConsentDialog.printVoucher')}
      </Button>
    </DialogActions>
  </Dialog>
}
export default withTranslation()(withStyles(styles)(FullpageCampaignConsentDialog));
